import axios from "axios";
import type { TFunction } from "i18next";

export function getErrorMessage(error: unknown) {
    if(error instanceof Error) return error.message;
    return String(error);
}

export const getApiErrorMessage = (error: unknown, translate?: TFunction): string => {
    if (axios.isAxiosError(error)) {
        const data = error.response?.data;
        const code = data?.code;
        const message = data?.message ?? error.message;
        if (translate && code) {
            const result = translate(code, message, data?.arguments);
            return typeof result === 'string' ? result : message;
        }
        return message;
    }
    return getErrorMessage(error);
};